import api from '../Utils/api'

export const getUserInfo = async () => {
  const apiResponse = await api('GET', 'users/info', null)
  return apiResponse
}

export const getConnectionUrl = async (ref) => {
  const apiResponse = await api(
    'GET',
    `auth/google/get-connection-url?ref=${ref}`,
    null,
    null
  )
  return apiResponse
}

export const fetchAllUsers = async () => {
  const apiResponse = await api('GET', 'users', null)
  return apiResponse
}

export const updateUserChecklistStatus = async (checkId) => {
  const apiResponse = await api('PATCH', 'users', { checkId }, true)
  return apiResponse
}

export const getZoomConnectionUrl = async (email) => {
  const apiResponse = await api(
    'GET',
    `zoom/get-connection-url?email=${email}`,
    null,
    null
  )
  return apiResponse
}
